export const enum UserType {
  ACM = "ACM",
  OPERATIONS_HFCL = "Operations HFCL",
  FCU_AGENT = "FCU Agent",
  FCU_MANAGER = "FCU Manager",
  FCU_ADMIN = "FCU Admin"
}
